import React from 'react';
import PropTypes from 'prop-types';

const Lozenge = ({
	label,
	size = 'small',
}) => (
	<div
		className={`lozenge ${size === 'large' ? 'is-large' : ''} color-${label.toLowerCase()}`}
	>
		{label}
	</div>
);

export default Lozenge;

Lozenge.propTypes = {
	label: PropTypes.string.isRequired,
	size: PropTypes.string,
};
